/**
 * 通用 Banner 轮播
 * */
import React, { useRef } from 'react';
import qs from 'qs';
import { Carousel } from 'antd';
import Utils from '../../script/util';
import { _h5_link_to } from '../../store/Action';
import IframeModal from '../iframModal/IframModal';
import './index.scss';

const BannerCarousel = (props) => {
  /* eslint-disable */
  const {
    className,
    autoplay = false,
    data,
    size = '288x88',
    isDirection = true,
    customClickBanner = null,
  } = props;
  const carouselRef = useRef(null);
  const iframeElement = useRef(null);

  // 点击 Banner
  const clickBanner = (item) => {
    if (customClickBanner) {
      customClickBanner(item);
    } else {
      if (!item?.url) return;
      _h5_link_to(item.url).then((res) => {
        iframeElement.current.showModal(
          res.url + '?' + qs.stringify(res.params)
        );
      });
    }
  };
  // 控制方向
  const clickDirection = (direct) => {
    if (!carouselRef.current) return;
    if (direct) {
      carouselRef.current.next();
    } else {
      carouselRef.current.prev();
    }
  };

  return !!data?.length ? (
    <div className={Utils.classNames('common-banner-carousel', className)}>
      <Carousel autoplay={autoplay} ref={carouselRef}>
        {data.map((item) => (
          <div
            key={item.id}
            className="common-banner-item"
            onClick={() => clickBanner(item)}
          >
            <img
              src={Utils.transImgUrl(item?.pic || null, size)}
              alt={item?.bannerName || ''}
            />
          </div>
        ))}
      </Carousel>
      {!!isDirection && data?.length > 1 && (
        <>
          <div
            className="common-btn-direction prev"
            onClick={() => clickDirection(false)}
          >
            {/*上一个*/}
          </div>
          <div
            className="common-btn-direction next"
            onClick={() => clickDirection(true)}
          >
            {/*下一个*/}
          </div>
        </>
      )}

      {/* 通用弹窗 */}
      <IframeModal wrappedComponentRef={iframeElement} />
    </div>
  ) : null;
};

export default BannerCarousel;
